<template>
  <div class="post-tab" :class="{ active: active, disabled }">
    {{ $t(tab.name) }}
  </div>
</template>

<script>
export default {
  name: "PostTab",

  props: {
    active: {
      required: true,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    tab: {
      required: true,
      type: Object
    }
  }
};
</script>

<style scoped lang="scss">
.post-tab {
  display: flex;
  align-items: center;
  padding: $spacing * 2 15px;
  text-align: center;
  cursor: pointer;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  box-shadow: inset 0px -1px 0px 0px $gray-200;
  color: rgba($text, 0.5);
  &:not(.disabled):hover {
    background: $base-light;
    color: $text;
  }
  &.active {
    box-shadow: inset 0px -2px 0px 0px $primary;
    color: $text;
  }

  &.disabled {
    cursor: unset;
  }

  div {
    line-height: 21px;
  }
}
</style>
